@if (title != null && message != null) {
    <div class="container">
        <div class="container-flex d-flex col-md-6 m-4">
            <div class="card m-2 p-4 w-100 text-center">
                <h2>{{title}}</h2>
                <hr />
                <p><b>{{message}}</b></p>
            </div>
        </div>
    </div>
}
